import React from 'react';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import { Link } from 'react-router';
import immutableCreatorSelector from '../../../../../../selectors/immutableCreatorSelector';
import { currentProjectIdSelector } from '../../../../../../reducers/projects';

const CurrentProjectIdSelector = immutableCreatorSelector(
  [currentProjectIdSelector],
  currentProjectId => ({
    currentProjectId,
  }),
);

@withApollo
@connect(CurrentProjectIdSelector)
class SearchModal extends React.Component {
  state = {
    value: null,
  };

  debouncedFetch = debounce(async () => {
    switch (this.props.type) {
      case 'organizations':
        await this.getOrganizations(this.state.value);
        break;
      case 'accounts':
        await this.getAccounts(this.state.value);
        break;
      // case 'projects':
      //   await this.getOrganizations(this.state.value);
      //   break;
      default:
        await this.getElements(this.state.value);
        break;
    }
  }, 500);

  handleOnChange = option => {
    // const { currentProjectId } = this.props;
    // const url = `/project/${currentProjectId}/element/${option.value}`;
    // dispatch(push(url));
  };

  handleChange = event => {
    this.setState({ value: event.target.value }, this.debouncedFetch);
  };

  getElements = async input => {
    const { client, currentProjectId } = this.props;

    if (!input) {
      return { options: [] };
    }

    const results = await client.query({
      query: gql`
        query Search($projectId: String!, $query: String!) {
          search(projectId: $projectId, query: $query) {
            id
            name
          }
        }
      `,
      variables: {
        projectId: currentProjectId,
        query: input,
      },
    });

    console.log('results', results);

    this.setState({ results: results.data.search });

    // return {
    //   options: results.data.search.map(s => ({ value: s.id, label: s.name })),
    // };
  };

  getOrganizations = async input => {
    const { client } = this.props;

    if (!input) {
      return { options: [] };
    }

    const results = await client.query({
      query: gql`
        query SearchOrganizations($query: String!) {
          searchOrganizations(query: $query) {
            id
            name
          }
        }
      `,
      variables: {
        query: input,
      },
    });

    this.setState({ results: results.data.searchOrganizations });
  };

  getAccounts = async input => {
    const { client } = this.props;

    if (!input) {
      return { options: [] };
    }

    const results = await client.query({
      query: gql`
        query SearchAccounts($query: String!) {
          searchAccounts(query: $query) {
            id
            name
          }
        }
      `,
      variables: {
        query: input,
      },
    });

    this.setState({ results: results.data.searchAccounts });
  };

  formatLink = result => {
    let urlPath;

    switch (this.props.type) {
      case 'organizations':
        urlPath = `/organizations/${result.id}`;
        break;
      case 'accounts':
        urlPath = `/accounts/${result.id}`;
        break;
      case 'projects':
        urlPath = `/project/${result.id}`;
        break;
      default:
        urlPath = `/project/${this.props.currentProjectId}/element/${
          result.id
        }`;
        break;
    }

    return (
      <Link to={urlPath} onClick={this.handleClick}>
        <h5 className="mb-1">{result.name}</h5>
      </Link>
    );
  };

  placeHolderText = text => {
    return text[0].toUpperCase() + text.slice(1);
  };

  componentDidMount() {
    this.searchInput.focus();
  }

  handleClick = () => {
    const { closePortal } = this.props;
    closePortal();
  };

  render() {
    const { results } = this.state;

    const placeHolderText = this.props.type
      ? `Search ${this.placeHolderText(this.props.type)}...`
      : 'Search...';

    return (
      <div>
        <input
          ref={input => (this.searchInput = input)}
          type="text"
          className="form-control"
          onChange={this.handleChange}
          style={{ marginBottom: 5, fontSize: 20, border: 0 }}
          placeholder={placeHolderText}
        />
        <div className="list-group list-group-flush">
          {results &&
            results.map(result => (
              <li className="list-group-item flex-column align-items-start" key={result.id}>
                <div className="d-flex w-100 justify-content-between">
                  {this.formatLink(result)}
                </div>
              </li>
            ))}
        </div>
      </div>
    );
  }
}

export default SearchModal;



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/SearchIcon/SearchModal.js